import { render, staticRenderFns } from "./NewsRichTextEditor.vue?vue&type=template&id=01a794fd&scoped=true"
import script from "./NewsRichTextEditor.vue?vue&type=script&lang=js"
export * from "./NewsRichTextEditor.vue?vue&type=script&lang=js"
import style0 from "./NewsRichTextEditor.vue?vue&type=style&index=0&id=01a794fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01a794fd",
  null
  
)

export default component.exports